
import React from 'react';
import { BarChart2, FileText, Clock, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const RSEValocap = () => {
  const features = [
    {
      icon: BarChart2,
      title: "Indicateurs RSE en temps réel",
      description: "Suivez vos taux de valorisation, économies de CO2 et performances environnementales"
    },
    {
      icon: FileText,
      title: "Rapports RSE automatisés",
      description: "Générez automatiquement vos rapports de développement durable"
    },
    {
      icon: Clock,
      title: "Aide à la décision stratégique",
      description: "Analysez vos données pour orienter vos choix vers plus de durabilité"
    }
  ];

  const advantages = [
    "Traçabilité complète de vos déchets pour vos rapports RSE",
    "Calcul automatique de votre empreinte carbone évitée",
    "Tableaux de bord personnalisés selon vos objectifs RSE",
    "Données fiables pour vos communications RSE",
    "Identification des opportunités d'amélioration"
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-fabre-lightgray to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-4 text-fabre-gray">
            VALOCAP : Votre Outil d'Aide à la Décision RSE
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Plateforme digitale pour optimiser votre stratégie RSE
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-gray-600 mb-8 text-lg leading-relaxed">
              Pour accompagner votre démarche RSE, nous mettons à votre disposition VALOCAP, 
              notre plateforme digitale qui vous aide à prendre les bonnes décisions stratégiques 
              en matière de gestion des déchets.
            </p>
            
            <div className="space-y-6 mb-8">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                  <div className="mr-4 p-3 bg-fabre-lightgreen rounded-xl">
                    <feature.icon className="h-6 w-6 text-fabre-green" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-2 text-fabre-gray">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
            
            <div className="flex flex-wrap gap-4">
              <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
                <Link to="/valocap">
                  Découvrir VALOCAP
                </Link>
              </Button>
              <Button 
                variant="outline" 
                className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen"
                onClick={() => window.open('https://www.valocap.fr/', '_blank')}
              >
                Accéder à la plateforme
              </Button>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h3 className="text-xl font-bold text-fabre-gray mb-6 text-center">
              Les Avantages VALOCAP pour Votre RSE
            </h3>
            <ul className="space-y-4">
              {advantages.map((advantage, index) => (
                <li key={index} className="flex items-start">
                  <CheckCircle className="h-5 w-5 text-fabre-green mr-3 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-700">{advantage}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RSEValocap;
